export default function(taggedOps, phrase) {
  return taggedOps.filter((tagObj, tag) => tag.indexOf(phrase) !== -1)
}



// WEBPACK FOOTER //
// ./src/core/plugins/filter/opsFilter.js